import Controller from "../class.Controller.js";
import TransporterLog from "../class.TransporterLog.js";

const Set = window.Set;

// eslint-disable-next-line no-unused-vars
const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterAnalyticsReporter",
		color: "#a6ff6e",
	},
});

export default class TransporterAnalyticsReporter extends Controller {
	/**
	 * @param {object} options
	 * @param {object} options.attributes
	 * @param {TransporterAnalytics} options.attributes.controller
	 * @param {TransporterAnalyticsMock} options.attributes.mock
	 */
	constructor(options) {
		super(options);

		this.queue = [];
		this.waiting = false;

		this.ajax = new AoPS.Ajax.ScriptRunner("/m/class/ajax.php", {
			filter_interval: 0,
		});

		this.initialize();
	}

	initialize() {
		const error = _.bind(LOGGER.error, LOGGER);
		LOGGER.error = (...n) => {
			if (this.controller.isEnabled()) {
				this.controller.incrementErrorCount();
				error(...n);
			}
		};
	}

	report() {
		if (this.controller.isEnabled()) {
			if (this.mock) {
				const data = this.getDataFromMock();
				if (data.length) {
					const task = {
						data,
						report: JSON.stringify(data),
					};
					this.updateReportedAt(data);
					this.queue.push(task);
					this.processQueue();
				}
			}
		}
	}

	processQueue() {
		if (this.controller.isEnabled()) {
			if (this.waiting) {
				return;
			}
			if (this.queue.length) {
				const task = this.queue[0];
				this.ajax.run(
					"transporter_analytics_submit_report",
					{report: task.report},
					(success, response) => {
						this.waiting = false;
						if (success) {
							// this.updateReportedAt(task.data);
							this.queue.shift();
							this.processQueue();
						} else {
							LOGGER.error(response);
						}
					}
				);
			}
		}
	}

	updateReportedAt(data) {
		const time = Date.now();
		for (let playthrough of data) {
			for (let item of playthrough.items) {
				for (let trial of item.trials) {
					trial.ta_reported_at = time;
					trial.ta_needs_reported = false;
				}
				item.ta_reported_at = time;
				item.ta_needs_reported = false;
			}
			playthrough.ta_reported_at = time;
			playthrough.ta_needs_reported = false;
		}
	}

	getDataFromMock() {
		let result = [];

		// First let's propagate the "ta_updated_at" date from children
		// to their parents.
		const trials = this.mock.trials.filter(this.needsReported);
		const items = [
			...new Set(
				this.mock.items
					.filter(this.needsReported)
					.concat(this.getParents(trials, "item_id", "items"))
			),
		];
		const playthroughs = [
			...new Set(
				this.mock.playthroughs
					.filter(this.needsReported)
					.concat(this.getParents(items, "playthrough_id", "playthroughs"))
			),
		];
		for (let playthrough of playthroughs) {
			// Get the playthrough's items.
			playthrough.items = items.filter(
				(item) => item.playthrough_id === playthrough.id
			);
			for (let item of playthrough.items) {
				// Get the item's trials.
				item.trials = trials.filter((trial) => trial.item_id === item.id);
			}
			result.push(playthrough);
		}
		return result;
	}

	getParents(rows, parentKey, parentTable) {
		const result = new Set();
		for (let row of rows) {
			result.add(this.mock[parentTable][row[parentKey]]);
		}
		return [...result];
	}

	needsReported(row) {
		return row.ta_needs_reported;
	}
}
